import { useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
import Layout from "../Layouts/Layout.jsx";
import Spinner from "../components/Spinner.jsx";
import Notifications from "../components/Notifications.jsx";
import SettingsThresholds from "../components/SettingsThresholds.jsx";

export default function Settings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getSettings = async () => {
    const apiBaseURL = import.meta.env.VITE_API_BASE_URL;
    let response = null;
    try {
      response = await fetch(apiBaseURL + "settings", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
    } catch (error) {
      Sentry.captureException(error);
      setError(error.message);
      console.error("API fetch error:", error);
      return;
    }
    if (response.status !== 200) {
      setError(await response.text());
      return;
    }
    setSettings(await response.json());
    setLoading(false);
  };

  useEffect(() => {
    getSettings();
  }, []);

  if (loading) {
    return (
      <Layout title="Dashboard">
        <div className="container w-full rounded-xl bg-white shadow p-4 h-screen">
          <Spinner />
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout title="Dashboard">
        <div className="container w-full rounded-xl bg-white shadow p-4 min-h-40">
          <div>Error loading TK: {error}</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="Settings">
      <SettingsThresholds thresholds={settings.thresholds} />
      {
        // TODO: <Notifications />
      }
    </Layout>
  );
}
